<ng-container
  *ngIf="isLoaded && fields"
  [formGroup]="responseForm">
  <div
    *ngFor="let field of fields"
    style="margin-bottom: 5px">
    <app-consent-form-field
      [formControlName]="field.name"
      [config]="field"
      [locale]="locale"
      [showErrors]="showErrors"
      (updated)="propagateFieldUpdate($event)"></app-consent-form-field>
  </div>
</ng-container>
